<template>
  <v-card class="card-border">
    <v-card-text>
      <v-btn
        outlined
        color="blue darken-2"
        rounded
        dark
        depressed
        small
        @click="$refs.dialogFinanciamento.show(false, {})"
      >
        <v-icon left>mdi-plus-circle</v-icon>Novo Financiamento
      </v-btn>
      <DialogFinanciamento ref="dialogFinanciamento" @created="created($event)" />
      <v-form ref="form">
        <v-row dense align="center">
          <v-col cols="2">
            <SelectAtivo @onChanged="itemsSelectAtivo = $event" />
          </v-col>
          <v-col cols="5">
            <v-btn outlined color="blue darken-2" rounded dark depressed small @click="buscar()">
              <v-icon left>mdi-magnify</v-icon>Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Financiamento from "@/services/financiamento";

export default {
  name: "Filtro",

  components: {
    DialogFinanciamento: () => import("./DialogFinanciamento"),
    SelectAtivo: () => import("@/components/select/SelectAtivo")
  },

  data() {
    return {
      empresas: [],
      serviceFinanciamento: new Financiamento(),
      itemsSelectAtivo: ""
    };
  },

  methods: {
    ...mapActions("financiamento", ["setFinanciamentos"]),

    async buscar() {
      try {
        if (this.$refs.form.validate()) {
          const response = await this.serviceFinanciamento.getByAtivo(
            this.itemsSelectAtivo == "Sim" ? true : false
          );
          this.setFinanciamentos(response);
        }
      } catch (error) {
        this.$toast.error(`Erro ao buscar os dados`);
      }
    },

    created(financiamento) {
      if (this.getFinanciamentos === null) {
        this.setFinanciamentos([{ ...financiamento }]);
      } else {
        this.setFinanciamentos(
          this.getFinanciamentos.concat(...[{ ...financiamento }])
        );
      }
    }
  },

  computed: {
    ...mapGetters("financiamento", ["getFinanciamentos"])
  },

  async mounted() {
    try {
      if (this.getFinanciamentos.length === 0) {
        const response = await this.serviceFinanciamento.getByAtivo(true);
        this.setFinanciamentos(response);
      }
    } catch (error) {
      this.$toast.error(`Erro ao buscar os dados`);
    }
  }
};
</script>
